import Keycloak from "keycloak-js";

let keycloak: Keycloak.KeycloakInstance;
let timerStarted: boolean;

const keyClientId = "KeycloakClientId";
const keyEnabled = "KeycloakEnabled";
const keyIdentityProviderHint = "KeycloakIdentityProviderHint";
const keyLocale = "KeycloakLocale";
const keyRealm = "KeycloakRealm";
const keyRedirectUri = "KeycloakRedirectUri";
const keyToken = "KeycloakToken";
const keyTokenRefresh = "KeycloakTokenRefresh";
const keyUrl = "KeycloakUrl";

export async function getToken(): Promise<string> {
	if (!isKeycloakEnabled()) {
		return null;
	}

	const keycloakUrl = getValue(keyUrl);
	const keycloakRealm = getValue(keyRealm);
	const keycloakClientId = getValue(keyClientId);
	const keycloakRedirectUri = getValue(keyRedirectUri);
	const keycloakIdentityProviderHint = getValue(keyIdentityProviderHint);

	if (!keycloakUrl || !keycloakRealm || !keycloakClientId || !keycloakRedirectUri) {
		return null;
	}

	if (keycloak) {
		await keycloak.updateToken(-1);
	} else {
		keycloak = new Keycloak({
			url: keycloakUrl,
			realm: keycloakRealm,
			clientId: keycloakClientId,
		});
		try {
			await keycloak.init({
				onLoad: "check-sso",
				redirectUri: keycloakRedirectUri,
				silentCheckSsoRedirectUri: window.location.origin + "/WebAccess/silent-check-sso.html",
			});
			startTokenTimer();
		} catch (err) {
			console.log(err);
			window.location.replace(window.location.origin + "/WebAccess/login.html");
		}
	}

	setValue(keyToken, keycloak.token);
	return keycloak.token;
}

export function getTokenSync(): string {
	if (!isKeycloakEnabled()) {
		return null;
	}

	return getValue(keyToken);
}

export async function login(prevLocation: string): Promise<void> {
	if (!isKeycloakEnabled()) {
		return null;
	}

	const keycloakUrl = getValue(keyUrl);
	const keycloakRealm = getValue(keyRealm);
	const keycloakClientId = getValue(keyClientId);
	const keycloakRedirectUri = getValue(keyRedirectUri);
	const keycloakLocale = getValue(keyLocale);
	const keycloakIdentityProviderHint = getValue(keyIdentityProviderHint);

	if (!keycloakUrl || !keycloakRealm || !keycloakClientId || !keycloakRedirectUri || !keycloakLocale) {
		return null;
	}

	if (!keycloak) {
		keycloak = new Keycloak({
			url: keycloakUrl,
			realm: keycloakRealm,
			clientId: keycloakClientId,
		});
		await keycloak.init({
			redirectUri: keycloakRedirectUri + prevLocation,
		});
	}

	keycloak.login({
		locale: keycloakLocale,
		idpHint: keycloakIdentityProviderHint,
	});
}

export async function logout(): Promise<void> {
	if (!isKeycloakEnabled()) {
		return null;
	}

	setKeycloakEnabled(false);
	keycloak.logout({ redirectUri: window.location.origin + "/WebAccess/login.html" });
}

export async function logoutOnError():Promise<void>  {
	if (!isKeycloakEnabled()) {
		return;
	}

	await keycloak.logout({ redirectUri: window.location.origin + "/WebAccess/error.html" });
}

export function setKeycloakEnabled(enabled: boolean): void {
	setValue(keyEnabled, enabled.toString());
}

export function setKeycloakParams(url: string, realm: string, clientId: string, redirectUri: string, tokenRefresh: string, locale: string, identityProviderHint: string): void {
	setValue(keyUrl, url);
	setValue(keyRealm, realm);
	setValue(keyClientId, clientId);
	setValue(keyRedirectUri, redirectUri);
	setValue(keyTokenRefresh, tokenRefresh);
	setValue(keyLocale, locale);
	setValue(keyIdentityProviderHint, identityProviderHint);
}

export function isKeycloakEnabled(): boolean {
	return getValue(keyEnabled) == "true";
}

function startTokenTimer(): void {
	if (!isKeycloakEnabled() || timerStarted) {
		return null;
	}

	timerStarted = true;
	window.setInterval(getToken, parseInt(getValue(keyTokenRefresh)));
}

function getValue(key: string): string {
	return window.sessionStorage.getItem(key);
}

function setValue(key: string, value: string): void {
	window.sessionStorage.setItem(key, value);
}